import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_INQ001_Request,
  IAPI_INQ001_Response,
} from "../../../type/apiType";

// 検索該当一覧参照
const httpAPI_INQ001 = async (
  param: IAPI_INQ001_Request
): Promise<IAPI_INQ001_Response> => {
  let res = await http.post(ApiUrl.API_INQ001, {
    ...param,
  });

  return res.data;
};

export { httpAPI_INQ001 };
